<template>
  <div class="content">
    <h2 class="has-text-centered">Öldrickartoppen</h2>
    <table class="table is-striped is-fullwidth">
      <thead>
        <tr class="beers-data__header">
          <th>Namn</th>
          <th class="has-text-centered" style="width:20%">Antal</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(topDrinker, index) in orderBy(topDrinkers, 'count', 'desc').slice(0, drinkersInList)" :key="index">
          <td>{{ topDrinker.name }}</td>
          <td class="has-text-centered">{{ topDrinker.count }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="2" class="has-text-right is-size-7 is-uppercase">
            <a @click="toggleDrinkersInList">{{drinkersInListButtonTxt}}</a>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>
<script>
import _ from 'lodash'

export default {
  data () {
    return {
      showAll: false
    }
  },
  computed: {
    drinkersInList: function () {
      return this.showAll ? -1 : 5
    },
    drinkersInListButtonTxt: function () {
      return this.showAll ? 'Visa topp 5' : 'Visa alla'
    },
    topDrinkers: function () {
      let data = this.$store.getters.data
      let raters = []
      let topDrinkers = []

      for (let i = 0; i < data.length; i++) {
        const element = data[i]

        if (element.ratings !== undefined) {
          let users = Object.keys(element.ratings)
          users.forEach(user => {
            raters.push(user)
          })
        }
      }

      // Group by name to sum up all names
      raters = _.groupBy(raters)

      // Get unique names
      let names = Object.keys(raters)

      names.forEach(name => {
        topDrinkers.push({name: raters[name][0], count: raters[name].length})
      })

      return topDrinkers
    }
  },
  methods: {
    orderBy: function (data, keys, order) {
      let sorted = _.orderBy(data, keys, order)
      return sorted
    },
    toggleDrinkersInList: function () {
      this.showAll = !this.showAll
    }
  }
}
</script>



// WEBPACK FOOTER //
// TopDrinkers.vue?3545cdec